<template>
  <v-card style="overflow: hidden;">
    <v-row class="pa-4 border-b--thin">
      Snapshots
    </v-row>

    <!-- pagination toolbar -->
    <v-row class="align-center pl-4 pr-2 pt-2 pb-2 border-b--thin">

      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <!-- ITEMS -->
        <div 
        v-if="selectedCount === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn outlined @click="axiosCreateNewItem">
            <v-icon>mdi-plus</v-icon>
            New
          </v-btn>

        </div>

        <!-- selected count -->
        <div v-if="selectedCount > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="selected = {}">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ selectedCount }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>
          <v-btn 
          icon
          @click="onDelete">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>

      <v-spacer></v-spacer>

      <div>
        <transition
        name="fade-transition"
        mode="out-in">
          <v-layout v-if="isLoading" key="L1" class="mr-2" align-baseline>
            <span class="grey--text caption">LOADING...</span>&nbsp;
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <div v-else key="L2"></div>
        </transition>
      </div>

    </v-row>

    <!-- TABLE -->
    <table class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="45px">
        <col width="15px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="Name"
        code="id"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="?"
        code="batch_number"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

      </tr>

      <tr class="disable-hover">
        <td>
          <v-text-field
          v-model="filters.search.name"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          color="color1"
          solo>
          </v-text-field>
        </td>
        <td></td>
      </tr>

      <row
      v-for="item in items" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      :selected="selected"
      @checkRow="checkRow(item)"
      @click.native="clickRow(item)"
      ></row>

    </table>
    <!-- TABLE -->

    <!-- PAGINATION -->
    <c-pagination
    compact
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->

  </v-card>
</template>

<script>
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListRouteBindings'
import Row from './row'

export default {
  mixins: [ServerListController, ServerListBindings],
  components: {
    Row
  },
  data () {
    return {
      page: 0,
      filters: {
        rowsPerPage: 10,
        sortCol: 'id',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          name: ''
        },
        active: {
          customer: false,
          date: false
        }
      },
      isLoading: false,
    }
  },
  methods: {
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.$emit('on-snapshot-selected', item)
      }
    },
    axiosCreateNewItem () {
      return new Promise((resolve, reject) => {
        this.$axios.post('/accounting/snapshots/create-new')
          .then(response => {
            this.loadAPI()
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    onDelete () {
      var idArray = this.getSelectedRows()
      var title = 'Delete ' + idArray.length + ' categor' + (idArray.length === 1 ? 'y' : 'ies') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          this.$axios.post('/accounting/snapshots/delete', idArray,
            {headers: {'X-Requested-With': 'XMLHttpRequest'}})
            .then(response => {
              this.selected = {} // This MUST be done after a successfull delete
              this.loadAPI()
            })
            .catch(error => this.$root.$errorSnackbar(error))
        }
      })
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/accounting/get-stock-snapshots?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var hrend = response.data.execution_time
            console.log(response)
            console.log('************************')
            // console.log(hrend)
            // console.info('Execution time (hr): %ds %dms', hrend[0], hrend[1] / 1000000)
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            if (this.items.length > rows.length) {
              this.currentIndex = 0
            }
            this.items = rows
            console.log(this.items)
            console.log('sccuess')
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>